import axios from "axios";

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL || "/api" });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    const issueRef = err.response?.data?.issue_ref;
    if (issueRef) {
      localStorage.setItem("ebek_last_error_ref", issueRef);
      err.response.data.error = `Something went wrong. Reference: ${issueRef}`;
    }
    // 401 on the login endpoint means wrong credentials — do NOT redirect,
    // let the Login component handle the error and show the message inline.
    const isLoginAttempt = err.config?.url?.includes("/auth/login");
    if (err.response?.status === 401 && !isLoginAttempt) {
      // Session expired or token invalid on a protected route → clear and go to login
      const keepChat  = localStorage.getItem("company_chat_keep_signed_in") === "1";
      const chatToken = localStorage.getItem("company_chat_token");
      const hrmsToken = localStorage.getItem("hrms_token"); // preserve for app switching
      localStorage.clear();
      if (keepChat) {
        localStorage.setItem("company_chat_keep_signed_in", "1");
        if (chatToken) localStorage.setItem("company_chat_token", chatToken);
      }
      if (hrmsToken) localStorage.setItem("hrms_token", hrmsToken);
      window.location.replace(process.env.REACT_APP_HRMS_LOGIN_URL || "http://localhost:5000/login");
    }
    return Promise.reject(err);
  }
);

export default API;
